import { render, staticRenderFns } from "./aweme-video-box.vue?vue&type=template&id=428826ba&scoped=true"
import script from "./aweme-video-box.vue?vue&type=script&setup=true&lang=js"
export * from "./aweme-video-box.vue?vue&type=script&setup=true&lang=js"
import style0 from "./aweme-video-box.vue?vue&type=style&index=0&id=428826ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428826ba",
  null
  
)

export default component.exports